/**
 * A2UI Row Component
 * Horizontal flex container for children
 */

import React from 'react';

const alignmentMap = {
  'start': 'flex-start',
  'center': 'center',
  'end': 'flex-end',
  'stretch': 'stretch',
  'baseline': 'baseline',
};

const justifyMap = {
  'start': 'flex-start',
  'center': 'center',
  'end': 'flex-end',
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly',
};

const A2UIRow = ({ 
  children,
  alignment = 'center',
  mainAxisAlignment = 'start',
  gap = 8,
  wrap = false,
  style,
  renderChildren,
  surfaceId
}) => {
  const rowStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: alignmentMap[alignment] || 'center',
    justifyContent: justifyMap[mainAxisAlignment] || 'flex-start',
    gap: `${gap}px`,
    flexWrap: wrap ? 'wrap' : 'nowrap',
    ...style
  };

  return (
    <div className="a2ui-row" style={rowStyle}>
      {renderChildren ? renderChildren(children) : null}
    </div>
  );
};

export default A2UIRow;
